module.exports = __webpack_public_path__ + "assets/no-data-undraw.2ceedf45.svg";